module.exports = __webpack_public_path__ + "assets/img/2_817_big.0a2ccb60.jpg";